export default [
  "Mbandaka", "GEMENA", "GBADOLITE", "Bandundu", "Kikwit", "KENGE",
  "Mbujimayi", "Mwene Ditu", "Lodja", "Kabinda", "Kananga", "TSHIKAPA",
  "Goma", "Goma MONUC", "Jambo Safari", "GOMA MAIRIE", "GOMA IHUSI HOTEL",
  "AGC Corporate", "GOMA RETAIL", "Goma DGM", "GOMA WALKIKALE", "Bukavu",
  "Bukavu MONUC", "PANORAMA", "Panzi", "BUKAVU DGDA", "ISP BUKAVU",
  "MAJOR VANGU", "BUKAVU INDEPEPENDANCE", "Kindu", "Beni", "Beni Monusco",
  "Butembo", "Uvira", "MONUSCO UVIRA", "Kisangani", "Bunia", "Bunia MONUC",
  "Goma Grande Barrier", "Place Du Marche", "Limete", "Memling", "Boulevard",
  "Victoire", "Galerie Du Fleuve", "Bon Marché", "Limete Plazza",
  "Congo BAT MONUC", "KIN HQ MONUC", "Hasson F Gare Centr", "Grand Hotel Kinshas",
  "Macampagne", "MoniShop", "Shoprite", "Police Armee Kin", "UPN", "Matete",
  "NDJILI", "HOTEL FLEUVE CONGO", "Agence Hotel du Gou", "Memling 2",
  "Bandalungwa", "UNIKIN", "HYPER PSARO", "GUICHET OASIS", "Lemba", "Lufu",
  "Matadi", "Guichet ledya", "Kwilu Ngongo", "Moanda", "Boma", "Kitona",
  "Moero", "Lomami", "Plage(Golf)", "Lumumba", "Stade Mazembe", "Ruashi",
  "Likasi", "CARREFOUR", "GALERIE AZZAS", "Golf Mall", "Kolwezi",
  "Palm Center Kol", "Tenke Fungurume", "Kalemie", "Kamina", "Kasumbalesa",
  "WISKI", "Manono"
]